export interface UnsubscribeActivityDto {
    id: string;
    emailAddress: string;
    emailUnsubscribeGroupId : string;
    unsubscribeDate: string;
    resubscribeDate?: string;
    rowSource?: string;
    isDeleted: boolean;
    deletedDate?: string;    
}

export class UnsubscribeActivitySearchDto {
    pageSize: number;
    sortFields: SortField[];
    filters: Filter[];
    pageNumber: number;
}

export interface SortField {
    property: string;
    sortType: string;
}

export interface Filter {
    property: string;
    value: string;
    operator: string;
}

export interface UnsubscribeActivitySearchResultDto {
    count: number;
    data: UnsubscribeActivityDto[];
}

export class UnsubscribeGroupDto {
    id: string;
    unsubscribeGroupName: string;
    unsubscribeGroupDesc: string;
    sendGridUnsubscribeGroupId: number;
    representsAllUnsubscribeGroups: boolean;
    isDeleted: boolean;
    deletedDate: string;   
    selected: string = 'false'; 
}

export class UnsubscribePreferencesDto {
    emailAddress: string;
    unsubscribeGroupIds: string[];
    resubscribeGroupIds: string[];
}

export class UnsubscribeGroupConfigDto {
    useGlobalUnsubscribeOnly: boolean;
    headerImageUrl: string;
    openingIntroductionText: string;
    emailAddressText: string;
    noteCheckbox1: string;
    noteCheckbox2: string;
    preferencesIntroductionText: string;
    globalUnsubscribeText: string;
    saveButtonText: string;
    saveProgressText: string;
}

export class TemplateResolutionRequestDto {
    public templateDefinitionId: string;
    public asFullHtmlDocument: boolean;
    public inputParams: TemplateInputParamDto[] = [];
}

export class TemplateInputParamDto {
    public queryParamName: string;
    public queryParamValue: string;
};

export class TemplateResolutionResponseDto {
    public templateFactDefinitionId: string;
    public resolvedTemplate: string;
}


export class EmailToDto {
    public name: string;
    public email: string;
}

export class SendEmailDto {
    public tos: EmailToDto[] = [];
    public cCs : EmailToDto[] = [];
    public bcCs : EmailToDto[] = [];
    public body: string;
    public subject: string;
    public isHtml: boolean = true;
    public attachments: [] = [];
    public notificationKey: string;
    public sendImmediately: boolean = true;
    public recipientId: string;
    public recipientClient: string;
    public templateDefinitionId: string;
    public bypassUnsubscribeListManagement: boolean = false;
}


export class  MemberClientResponse {
    memberId: string;
    clientId: string;
    clientCode: string;
}

export class  MemberIdentiiesResponse {
    memberId: string;
}

